import * as React from "react";
import Card from "./Card";

const CardLoading = (props: {}) => {
	return (
		<Card loading={true}>
			<div className="stripe stripe-1"></div>
			<div className="stripe stripe-2"></div>
			<div className="stripe stripe-3"></div>
			<div className="stripe stripe-4"></div>
		</Card>
	);
};

CardLoading.displayName = "CardLoading";
export default CardLoading;
